import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ClientsResponseDto, ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class UpdateDriverVehicleCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IUpdateDriverVehicleCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'carriers/{carrierUserId}/drivers/{driverUserId}/updateVehicle?vehicleId={vehicleId}';

  override setParameters(parameters: IUpdateDriverVehicleCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{driverUserId}',
      parameters.driverUserId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{vehicleId}',
      parameters.vehicleId.toString()
    );  }
}

export interface IUpdateDriverVehicleCommandParameters
  extends ICommandParameters {
    carrierUserId: string;
    driverUserId: number;
    vehicleId: number;
  }
